import React, { Component } from "react";
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import store from "../../../../../store";

import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import { MAX_LENGTH } from "../../../../../constants/external-constants";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import AddPlanComponent from "../../../../common/plan-component/add-plan-component";
import { planCatalogueActions } from "../../../../../store/external/finance/plan-catalogue.reducer";
import { isObjectEqual, areDataEqual } from "../../../../../utils/helpers.utils";
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";


class PlanCatalogueFormView extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            viewDetailPage: false,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            planId: 0,
            activeDropdown: null,
            originalPlanComponentData:{},
            isLoading: true,
            haveFieldError: false
        }

    }

    componentDidMount() {
        this.fetchPlanCatalogueData();
        window.scrollTo(0, 0);
    }

    fetchPlanCatalogueData = async () => {
    const { 
        getActivePlanVendors, 
        getPlanRateStatus, 
        getCircuitTypes, 
        planDetailsId, 
        getPlanDetailsForm, 
        getFinancePlanComponent, 
        resetFinancePlanComponent, 
        resetFinancePlanForm,
        getSelectedVendor, 
        getSelectedServiceType,
        isCreateNew 
    } = this.props;


     if (!isCreateNew && planDetailsId > 0) {
        await getPlanDetailsForm(planDetailsId);
        await getFinancePlanComponent(planDetailsId).then(() => {
        const originalPlanComponentDataCopy = JSON.parse(
            JSON.stringify(this.props.planCatalogue.planComponents?.dataTable[0]?.dataItem)
        );
        this.setState({ originalPlanComponentData: originalPlanComponentDataCopy });
        });

    }

    // preload plan rate status
    await getPlanRateStatus();

    // vendor logic
    const { vendorDetailId, circuitTypeId } = this.props.planCatalogueDetailsForm;
    if (vendorDetailId) {
        const vendorName = await getSelectedVendor(vendorDetailId);
        await getActivePlanVendors(1, vendorName);
    } else {
        await getActivePlanVendors(1);
    }

    // service type logic
    if (circuitTypeId) {
        const serviceTypeName = await getSelectedServiceType(circuitTypeId);
        await getCircuitTypes(1, serviceTypeName);
    } else {
        await getCircuitTypes(1);
    }

    this.setState({
        isLoading: false,
        haveFieldError: false
    });
    }

    componentWillUnmount(){
         const { 
            resetFinancePlanComponent, 
            resetFinancePlanForm,
        } = this.props;

        resetFinancePlanForm();
        resetFinancePlanComponent();
    }


    handleButtonConfirmation = async (planId = 0, validate = 1) => {
        const { savePlanCatalogue, planCatalogueDetailsForm, isCreateNew } = this.props;
        const { dataTable } = this.props.planCatalogue.planComponents;

        if (!dataTable[0].dataItem.length) {
            const modalTitle = this.toLocaleLanguage("modal_error_title")
            const modalMessage = this.toLocaleLanguage("plan_should_have_atleast_one_component")

            this.toggleSaveNotif(true, modalTitle, modalMessage);

        }
        else {
            var result = await savePlanCatalogue(planId, validate);

            this.setState({
                isSaving: false
            });
            if (result.success === false) {
                if (result.isValid) {
                    if (!isCreateNew) {
                        const confirmMessage = this.toLocaleLanguage("save_confirmation");
                        const modalTitle = this.toLocaleLanguage("call_save");
                        var confirmAction = () => this.handleButtonConfirmation(planId, 0);
                        this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                        return;
                    }
                    else{
                        this.handleButtonConfirmation(planId, 0);
                        return;
                    }
                }
                else {
                    if (result.isExist) {

                        this.toggleSaveModal(false);
                        this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                        this.setState({
                            haveFieldError: true
                        })
                        return;
                    }
                }
            }
            else if (result.success === true){
                var isNewPlan = planCatalogueDetailsForm.planId === 0;

                const modalMessage = isNewPlan ? this.toLocaleLanguage("plan_has_been_created") : this.toLocaleLanguage("plan_has_been_updated");
                const modalTitle = this.toLocaleLanguage("success_modal_title");

                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, modalTitle, modalMessage);

                return;
            }
        }
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = async (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, getPlanCatalogue, resetFinancePlanForm, getPlanDetailsForm, getFinancePlanComponent, planDetailsId } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("plan_has_been_created")) {
            handleCloseForm();
            getPlanCatalogue();
            resetFinancePlanForm();
        }
        if (!isShow && saveNotif.message === this.toLocaleLanguage("plan_has_been_updated")){
            this.setState({isLoading:true});
            await getPlanDetailsForm(planDetailsId);

            await getFinancePlanComponent(planDetailsId).then(()=>{
                const originalPlanComponentDataCopy = JSON.parse(JSON.stringify(this.props.planCatalogue.planComponents?.dataTable[0]?.dataItem));
                this.setState({  originalPlanComponentData: originalPlanComponentDataCopy, isLoading:false })
            });

            getPlanCatalogue();
        }
    }

    handleChangesStatus = (prop, truthValue) => {
        this.setState({
            [prop]: truthValue
        })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    disableSaveChanges = () => {
        const { $form, planCatalogueDetailsForm } = this.props 
        const { planName, vendorDetailId, circuitTypeId, rateStatusId } = planCatalogueDetailsForm;
        const { dataTable } = this.props.planCatalogue.planComponents;

        const isFieldEmpty = !planName || !vendorDetailId || !circuitTypeId || !rateStatusId;

            if (isFieldEmpty) {
                return true;
            }

            const unchangedPlanDetails = !$form.loadedValue ? true : isObjectEqual($form.loadedValue, planCatalogueDetailsForm);

            const planComponentDetails =  dataTable?.length > 0
                    ? areDataEqual(this.state.originalPlanComponentData, dataTable[0].dataItem)
                    : true;

            return unchangedPlanDetails && planComponentDetails;
    };

    handelToggleDropdown = (index, isShow = false) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === index && !isShow ? null : index
        }));
    }

    selectPlanCircuitType = (key) => {
        const { selectPlanCircuitTypeId } = this.props;
        selectPlanCircuitTypeId(key);
        this.setState({
            haveFieldError: false
        })
        store.dispatch(actions.resetErrors("planCatalogueDetailsForm.planName"))       
    }

    onSelectVendor = (key) => {
        const { selectVendorId } = this.props;
        selectVendorId(key);
        this.setState({
            haveFieldError: false
        })
        store.dispatch(actions.resetErrors("planCatalogueDetailsForm.planName"))
    }

    onChangePlan = (model, value) => {

        if (model === "planCatalogueDetailsForm.planName") {
            store.dispatch(actions.change("planCatalogueDetailsForm.planName", value))   
        }
        else if (model === "planCatalogueDetailsForm.rateStatusId") {
            store.dispatch(actions.change("planCatalogueDetailsForm.rateStatusId", value))   
        }

        this.setState({
            haveFieldError: false
        })
        store.dispatch(actions.resetErrors("planCatalogueDetailsForm.planName"))       
    }  
    loadMoreVendor = (searchString) => {
        const { planCatalogue, getActivePlanVendors } = this.props;
        getActivePlanVendors(planCatalogue.vendorListPage + 1, searchString);
    }
  
    handleSearchVendor = (query) => {        
        const {getActivePlanVendors} = this.props;
        getActivePlanVendors(1, query);
    } 

    loadMoreCircuit = (searchString) => {
        const { planCatalogue, getCircuitTypes } = this.props;

        getCircuitTypes(planCatalogue.circuitPage + 1, searchString);
    }
   
    handleSearchCircuit = (query) => {        
        const {getCircuitTypes } = this.props;
        getCircuitTypes(1, query);
    }

    render() {
        const { activePlanVendors, planRateStatus, planCircuitTypes } = this.props.planCatalogue;
        const { planCatalogue, planComponentForm, planDetailsId, isCreateNew  } = this.props;
        const { planName, vendorDetailId, circuitTypeId, rateStatusId, currency, description } = this.props.planCatalogueDetailsForm;
        const { isLoading, haveFieldError } = this.state

        var enableSaveButton = !planName || !vendorDetailId || !circuitTypeId || !rateStatusId;
        console.log("Dropdown props", {
        selected: this.props.planCatalogueDetailsForm.vendorDetailId,
        options: this.props.planCatalogue.activePlanVendors
        });

        return (
            <>
            {isLoading ? 
                <NoSubscription/> :
                <div className="add-plan-catalogue dispute-container">
                <div className="dispute-container details-field-container mb-3 capital-uppercase">

                    <InputField
                        className="form-control"
                        type="text"
                        label={`${this.toLocaleLanguage('plan_name')}`}
                        value={planName}
                        fieldProp='planCatalogueDetailsForm.planName'
                        maxLength={MAX_LENGTH.limit_100}
                        disabled={false}
                        requiredField
                        placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                        onChangeAction={this.onChangePlan}
                    />

                    <CustomSearchableDropdownWrapper 
                        label={this.toLocaleLanguage("vendor")}
                        options={this.props?.planCatalogue?.activePlanVendors}
                        selected={vendorDetailId}
                        onChange={(e) => this.onSelectVendor(e)}
                        requiredField
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='planCatalogueDetailsForm.vendorDetailId'
                        tagName='tagName'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleSearchVendor}
                        onLoadMore={(val) => this.loadMoreVendor(val)}
                        isLoading={!this.props?.planCatalogue?.planVendorsLoaded}
                        hasMore={this.props?.planCatalogue?.hasMoreVendor}
                    />

                    <CustomSearchableDropdownWrapper 
                        label={this.toLocaleLanguage("circuit_type")}
                        options={this.props?.planCatalogue?.planCircuitTypes}
                        selected={circuitTypeId}
                        onChange={(e) => this.selectPlanCircuitType(e)}
                        requiredField
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='planCatalogueDetailsForm.circuitTypeId'
                        tagName='tagName'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleSearchCircuit}
                        onLoadMore={() => this.loadMoreCircuit()}
                        isLoading={!this.props?.planCatalogue?.circuitListLoaded}
                        hasMore={this.props?.planCatalogue?.hasMoreServiceData}
                    />

                    <Select
                        className="form-select required"
                        label={`${this.toLocaleLanguage('status')}`}
                        options={planRateStatus}
                        value={rateStatusId}
                        placeholder={this.toLocaleLanguage('select_placeholder', false)}
                        isError={haveFieldError}
                        fieldProp='planCatalogueDetailsForm.rateStatusId'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        onChangeAction={this.onChangePlan}
                    />
                    <InputField
                        className="form-control"
                        type="text"
                        label={`${this.toLocaleLanguage('currency')}`}
                        value={currency}
                        fieldProp='planCatalogueDetailsForm.currency'
                        disabled={true}
                    />

                    <div className="grid-col-span-2 capital-uppercase">
                        <InputField
                            className="form-control"
                            type="text"
                            label={`${this.toLocaleLanguage('description')}`}
                            value={description}
                            fieldProp='planCatalogueDetailsForm.description'
                            maxLength={MAX_LENGTH.limit_255}
                            disabled={false}
                            placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                        />
                    </div>
                </div>

                
                    <AddPlanComponent
                        planDetailsId = {planDetailsId}
                        translator={(x) => this.toLocaleLanguage(x)}
                        toggleDropdown={this.handelToggleDropdown}
                        activeDropdown={this.state.activeDropdown}
                        planCatalogue={planCatalogue}
                        planComponentForm={planComponentForm}
                        planComponentAction={this.props}
                        handleChangesStatus = {this.handleChangesStatus}
                        isReadAndWrite = {this.props.isReadAndWrite}
                    />


                <div className='dispute-save-btn save-btn-container'>
                    <ConfirmationModal
                        ref={this.ConfirmationModal}
                        title={this.state.saveModal.title}
                        messageBody={this.state.saveModal.messageBody}
                        confirmAction={this.state.saveModal.confirmAction}
                        closeLabel={this.toLocaleLanguage("cancel_button", false)}
                        confirmLabel={this.toLocaleLanguage("yes_button", false)}
                        disabled={this.state.isSaving}
                    />

                    <NotificationModal
                        show={this.state.saveNotif.show}
                        title={this.state.saveNotif.title}
                        message={this.state.saveNotif.message}
                        handleModal={() => this.toggleSaveNotif(false)}
                        customClass={'comment-notification-modal modal-text-bold notification-footer'}
                    />

                    
                    <div className="tooltip-container">
                        <div className="btn-tooltiptext">
                            {this.props.isReadAndWrite &&
                                <Button
                                    className='save-details-btn btn btn-primary'
                                    disabled={isCreateNew ? enableSaveButton : this.disableSaveChanges()}
                                    type="button"
                                    onClick={() => this.handleButtonConfirmation(planDetailsId)}>
                                    Save Changes
                                </Button>
                            }
                            <div className="save-tooltip-text-container">
                                <span className="tooltip-text-save">{this.toLocaleLanguage("save_plan_details")}</span>
                            </div>

                        </div>
                    </div>
                 
                </div>
            </div>
            }
            </>
            
        )
    }
}


export default withRouter(
    connect(state => {
        const { planCatalogue, translation } = state;
        const { planCatalogueDetailsForm,
                forms: { planCatalogueDetailsForm: { $form } },
                planComponentForm
                } = state.form;

        return {
            translation
            , planCatalogue
            , $form
            , planCatalogueDetailsForm
            , planComponentForm
        };
    },
        dispatch => ({
            ...bindActionCreators(
                Object.assign({}
                    , planCatalogueActions),
                    dispatch
            ), 
            FormChange: (Model, value) => {
                dispatch(actions.change(Model, value))
            },
            FormLoad: (model, data) => {
                dispatch(actions.load(model, data));
            }
        })
    )(PlanCatalogueFormView)
);
